<ion-header class="header --w-back-button --underline">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.adminSurveyDefinitions" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title
      [innerHTML]="(surveyDefinitionSlug$ | async) ? (surveyDefinition$ | async)?.name : ('ADMIN_SURVEYS.CREATE' | translate)"
    ></ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons> </ion-toolbar
></ion-header>

<ion-content class="survey-definition-form">
  <div class="white-wrapper">
    <span
      class="survey-definition-form__title"
      [innerHTML]="(surveyDefinitionSlug$ | async) ? (surveyDefinition$ | async)?.name : ('ADMIN_SURVEYS.CREATE' | translate)"
    ></span>
    <form class="survey-definition-form__form" [formGroup]="form">
      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.NAME_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="name"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.TITLE_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="title"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.START_BUTTON_TEXT_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="startButtonText"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.SUCCESS_TITLE_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="successTitle"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.SUCCESS_TEXT_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="successText"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.SUCCESS_BUTTON_TEXT_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="successButtonText"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.SUCCESS_BUTTON_LINK_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="successButtonLink"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.DESCRIPTION' | translate"
        ></ion-label>
        <ion-textarea ngDefaultControl class="survey-definition-form__form__item__textarea" formControlName="description"></ion-textarea>
      </ion-item>

      <div class="survey-definition-form__form__buttons">
        <div
          *ngIf="(surveyDefinition$ | async)?.imageUrl || image?.base64String"
          class="survey-definition-form__form__buttons__remove"
          (click)="removeImage()"
        >
          x
        </div>
        <ion-button class="survey-definition-form__form__buttons__button" (click)="loadImage()">
          <ion-img
            *ngIf="image?.base64String; else adminSurveyImage"
            src="data:image/{{image.format}};base64,{{image.base64String}}"
          ></ion-img>
          <ng-template #adminSurveyImage>
            <ion-img *ngIf="(surveyDefinition$ | async)?.imageUrl; let source; else cameraIcon" [src]="source"></ion-img>
          </ng-template>
          <ng-template #cameraIcon><ion-icon name="camera"></ion-icon></ng-template>
        </ion-button>

        <div
          *ngIf="(surveyDefinition$ | async)?.successImageUrl || imageSuccess?.base64String"
          class="survey-definition-form__form__buttons__remove"
          (click)="removeImageSuccess()"
        >
          x
        </div>
        <ion-button class="survey-definition-form__form__buttons__button" (click)="loadImageSuccess()">
          <ion-img
            *ngIf="imageSuccess?.base64String; else adminSurveyImageSuccess"
            src="data:image/{{imageSuccess.format}};base64,{{imageSuccess.base64String}}"
          ></ion-img>
          <ng-template #adminSurveyImageSuccess>
            <ion-img *ngIf="(surveyDefinition$ | async)?.successImageUrl; let source; else cameraIcon" [src]="source"></ion-img>
          </ng-template>
          <ng-template #cameraIcon><ion-icon name="camera"></ion-icon></ng-template>
        </ion-button>
      </div>

      <div class="survey-definition-form__form__footer">
        <ion-button class="button --tertiary" [innerHTML]="'BUTTONS.CANCEL' | translate | lowercase" (click)="cancel()"></ion-button>
        <ion-button class="button --primary" [disabled]="form.invalid || form.pristine || (loading$ | async)" (click)="save()">
          <ion-spinner *ngIf="loading$ | async; else text"></ion-spinner>
          <ng-template #text>
            <span [innerHTML]="'BUTTONS.SAVE' | translate"></span>
          </ng-template>
        </ion-button>
      </div>
    </form></div
></ion-content>
